import React from "react";
import { Box } from "@mui/material";
import { COLORS } from "./constants";

// One status badge for the whole dashboard. There used to be four hand-built
// variants (different heights, radii and colours for the same LIVE/OFFLINE
// idea). Every state carries a word, never colour alone.
const STATES = {
  live:      { label: "Live",      color: COLORS.green, bg: "rgba(61,214,140,0.12)",  line: "rgba(61,214,140,0.34)", pulse: true },
  retrying:  { label: "Retrying",  color: COLORS.amber, bg: "rgba(244,183,64,0.12)",  line: "rgba(244,183,64,0.36)" },
  ready:     { label: "Ready",     color: COLORS.cyan,  bg: "rgba(43,189,175,0.12)",  line: "rgba(43,189,175,0.40)" },
  offline:   { label: "Off",       color: COLORS.muted, bg: "rgba(239,227,204,0.04)", line: COLORS.border },
  error:     { label: "Failed",    color: COLORS.red,   bg: COLORS.dangerSoft,        line: "rgba(229,72,77,0.40)" },
  scheduled: { label: "Scheduled", color: COLORS.cyan,  bg: "rgba(43,189,175,0.12)",  line: "rgba(43,189,175,0.40)" }
};

export function StatusBadge({ state, label }) {
  const s = STATES[state] || STATES.offline;
  return (
    <Box component="span" sx={{
      display: "inline-flex", alignItems: "center", gap: 0.75, flexShrink: 0,
      height: 24, px: 1.25, borderRadius: "999px",
      fontSize: 11, fontWeight: 600, letterSpacing: "0.07em", textTransform: "uppercase",
      whiteSpace: "nowrap", color: s.color, bgcolor: s.bg, border: `1px solid ${s.line}`
    }}>
      <Box component="span" sx={{
        width: 7, height: 7, borderRadius: "50%", bgcolor: "currentColor",
        animation: s.pulse ? "pulse 1.6s ease-in-out infinite" : "none",
        "@media (prefers-reduced-motion: reduce)": { animation: "none" }
      }} />
      {label || s.label}
    </Box>
  );
}
